import * as tslib_1 from "tslib";
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { LoaderService } from '../../loader/loader.service';
import { PlataformCommunicatorBitacaraService } from './plataform-communicator-bitacara.service';
import * as i0 from "@angular/core";
import * as i1 from "../../loader/loader.service";
import * as i2 from "./plataform-communicator-bitacara.service";
/**
 * Definición para que la clase sea visible desde root
 *
 * *Class definition to be seen from root*
 *
 * @type {Injectable}
 */
var PlatformCommunicatorInterceptor = /** @class */ (function () {
    function PlatformCommunicatorInterceptor(loaderService, plataformBitacora) {
        this.loaderService = loaderService;
        this.plataformBitacora = plataformBitacora;
        /**
         * Definición de la variable endpoints como PlatformEndpoint[] lista de endpoints cómo vacio
         *
         * *Defines endpoints variable as PlatformEndpoint[], empty endpoints list*
         *
         * @type {public}
         * @var {PlatformEndpoint[]} endpoints
         */
        this.endpoints = [];
    }
    /**
     * Funcíon que inicializa la variable endpoints con los endpoint del parámetros
     *
     * *Function sets endpoints variable with endpoints in params*
     *
     * @type {function}
     * @param {PlatformEndpoint[]} endpoints
     */
    PlatformCommunicatorInterceptor.prototype.setMockedEndPoints = function (endpoints) {
        this.endpoints = endpoints;
    };
    PlatformCommunicatorInterceptor.prototype.matchURL = function (url, method) {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.endpoints), _c = _b.next(); !_c.done; _c = _b.next()) {
                var endpoint = _c.value;
                var regularExpression = new RegExp(endpoint.url);
                if (!regularExpression.test(url) || method.toLowerCase() !== endpoint.method.toLowerCase()) {
                    continue;
                }
                return endpoint;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return null;
    };
    PlatformCommunicatorInterceptor.prototype.getBackEndURLMocked = function (urlMocked, url, method) {
        var case_number = localStorage.getItem('case_number') !== null ? localStorage.getItem('case_number') : '0';
        var endpoint = this.matchURL(url, method);
        return endpoint !== null && !endpoint.mock_response && !endpoint.mock_error && endpoint.urlMocked !== undefined ?
            urlMocked + endpoint.urlMocked + case_number + '.json' : url;
    };
    /**
     * Funcíon que intercepta las peticiones http
     *
     * *Function intercepts http request*
     *
     * @type {function}
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable}
     */
    PlatformCommunicatorInterceptor.prototype.intercept = function (request, next) {
        var _this = this;
        var requestUrl = request.url;
        var endpoint = this.matchURL(requestUrl, request.method);
        var validatEndPoint = /.*\html?|json|event|cronostest$/.test(requestUrl);
        if (!validatEndPoint) {
            this.loaderService.show(requestUrl);
        }
        if (endpoint !== null && endpoint.mock_response) {
            this.loaderService.hide(requestUrl);
            return of(new HttpResponse({ status: endpoint.response.status, body: (endpoint.response.body) }));
        }
        return next.handle(request).pipe(map(function (_event) {
            _this.throwMockedError(request);
            if (_event instanceof HttpResponse && _event.body !== null && _event.body.status !== undefined) {
                if (_event.body.status === 200) {
                    _event = _event.clone({ body: _event.body.body, status: _event.body.status });
                }
                else {
                    var error = { status: _event.body.status, error: _event.body.body };
                    throw new HttpErrorResponse(error);
                }
            }
            return _event;
        }), catchError(function (error) {
            _this.plataformBitacora.saveDataInBitacora(error);
            _this.loaderService.hide(requestUrl);
            _this.throwMockedError(request);
            throw error;
        }), finalize(function () {
            _this.loaderService.hide(requestUrl);
        }));
    };
    /**
     * Funcíon para lanzar un error como mock
     *
     * *Function that throws mocked error*
     *
     * @type {function}
     * @type {private}
     * @param {HttpRequest<any>} request
     * @param {HttpHandler} next
     * @returns {Observable}
     */
    PlatformCommunicatorInterceptor.prototype.throwMockedError = function (request) {
        var endpoint = this.matchURL(request.url, request.method);
        if (endpoint !== null && endpoint.mock_error) {
            var error = { status: endpoint.errorResponse.status, error: endpoint.errorResponse.body };
            throw new HttpErrorResponse(error);
        }
    };
    PlatformCommunicatorInterceptor.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlatformCommunicatorInterceptor_Factory() { return new PlatformCommunicatorInterceptor(i0.ɵɵinject(i1.LoaderService), i0.ɵɵinject(i2.PlataformCommunicatorBitacaraService)); }, token: PlatformCommunicatorInterceptor, providedIn: "root" });
    return PlatformCommunicatorInterceptor;
}());
export { PlatformCommunicatorInterceptor };
